import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "sip", emoji: "📊", title: "SIP Calculator", desc: "Estimate the corpus your monthly SIP can build." };

function SIPCalculator() {
  const [amount, setAmount] = useState(5000);
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(20);

  const months = years * 12;
  const i = rate / 100 / 12;
  // Future value of a series (SIP), investments at start of each month.
  const fv = i > 0 ? amount * ((Math.pow(1 + i, months) - 1) / i) * (1 + i) : amount * months;
  const invested = amount * months;
  const gains = fv - invested;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>How it works:</strong> SIP returns use monthly compounding. A
          higher tenure dramatically boosts your corpus thanks to compounding.
          Returns shown are estimates, not guaranteed.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Monthly investment (₹)" value={amount} onChange={setAmount} min={500} max={200000} step={500} prefix="₹" />
          <CalcField label="Expected return rate (% p.a.)" value={rate} onChange={setRate} min={1} max={30} step={0.5} suffix="%" />
          <CalcField label="Time period (years)" value={years} onChange={setYears} min={1} max={40} step={1} suffix="yr" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Total future value</div>
            <div className="big">{formatINR(fv)}</div>
          </div>
          <Row className="g-3">
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(invested)}</div>
                <small className="text-muted">Invested</small>
              </div>
            </Col>
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(gains)}</div>
                <small className="text-muted">Est. returns</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default SIPCalculator;
